export default __webpack_public_path__ + "static/media/hero.b3831af7.png";